import { Icon } from '@dynamic/ui';
import styled from 'styled-components';

import { Button } from '#/components/Button/Button';
import { Container } from '#/components/Form/FormInput/FormInput.styled';
import { PlanPickerMainText } from '#/plugins/paywall/components';
import { remify } from '#/service/utils';

export const VoucherForm = styled.form`
  display: grid;
  grid-template-columns: auto max-content;
  column-gap: ${remify(10)};
  max-height: ${remify(100)};

  /* removing input margin */
  & ${Container} {
    margin: 0;
  }
`;

export const VoucherFormSubmitButton = styled(Button)`
  font: var(--fontStyleCallout);
  height: ${remify(50)};
`;

export const VoucherText = styled(PlanPickerMainText).attrs(() => {
  return { 'data-testid': 'voucher-text' };
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--fontStyleBody);
`;

VoucherText.displayName = 'VoucherText';

export const VoucherApplied = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease-in;
  opacity: 0;
  max-height: 0;
  overflow: hidden;

  &.enter {
    opacity: 0;
    max-height: ${remify(28)};
  }

  &.enter-active {
    opacity: 1;
    max-height: ${remify(28)};
  }

  &.enter-done {
    opacity: 1;
    max-height: ${remify(28)};
  }
`;

export const VoucherRemoveButton = styled(Button)`
  padding: ${remify(4)};
  flex-shrink: 0;
  line-height: 0;
  color: inherit;
`;

export const VoucherRemoveIcon = styled(Icon)`
  height: ${remify(20)};
  width: ${remify(20)};
`;

export const VoucherInformation = styled.div`
  display: flex;
  align-items: center;
  color: var(--pageParagraphForeground);
  gap: ${remify(8)};
  margin-top: ${remify(16)};
`;

export const VoucherInformationIcon = styled(Icon)`
  flex-shrink: 0;
  height: ${remify(24)};
  width: ${remify(24)};
`;

export const VoucherInformationText = styled.span`
  font: var(--fontStyleFootnote);
`;
